import React, { useEffect, useState } from "react";
import { Toast, ToastBody, ToastHeader } from "reactstrap";

import { Actions, Message, State } from "../types";

import "./styles.scss";

type Props = Readonly<{
  hideMessage: Actions["hideMessage"];
  messages: State["messages"];
}>;

export const Messages = ({ hideMessage, messages }: Props) => {
  const [visible, setVisible] = useState(false);
  const [currentMessage, setCurrentMessage] = useState<Message | null>(null);
  useEffect(() => {
    if (messages.length > 0 && (!currentMessage || currentMessage.id !== messages[0].id)) {
      setCurrentMessage(messages[0]);
      setVisible(true);
      if (typeof messages[0].displaySeconds === "number") {
        setTimeout(() => {
          hideMessage(messages[0]);
        }, messages[0].displaySeconds * 1000);
      }
      return;
    }
    if (messages.length === 0 && visible) {
      setVisible(false);
    }
  }, [messages, setCurrentMessage, setVisible]);
  if (!currentMessage) {
    return null;
  }
  return (
    <Toast isOpen={visible}>
      <ToastHeader
        className="align-items-center d-flex justify-content-between"
        icon={currentMessage.icon}
        toggle={
          currentMessage.displaySeconds === undefined
            ? () => {
                hideMessage(currentMessage);
              }
            : undefined
        }
      >
        {currentMessage.title}
      </ToastHeader>
      <ToastBody>{currentMessage.content}</ToastBody>
    </Toast>
  );
};
Messages.displayName = "Messages";
